/*
 * @Description:
 * @Date: 2024-12-13 16:53:49
 * @LastEditTime: 2024-12-19 15:52:01
 */
import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import store from "./store";
import axios from "axios";
// 分页组件
import Pagination from "@/components/Pagination";
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.component("Pagination", Pagination);
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
